var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',[_c('tr',[_c('td',{style:(_vm.rowStyle),attrs:{"height":_vm.height}},[_vm._v(_vm._s(-(_vm.number*0.01).toFixed(1))+" ─")])]),_vm._l((4),function(n,index){return _c('tr',{key:index},[_c('td',{style:(_vm.rowStyle),attrs:{"height":_vm.height}},[_vm._v("-")])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }